import { IconSparkles } from '@posthog/icons';
import * as React from 'react';
export default {
  IconSparkles,
  React
};